enum ModelApiKeys {
  WwwNewsImageSection = "www_news_image_section",
  WwwNewsGallerySection = "www_news_gallery_section",
  WwwNewsImagesSection = "www_news_images_section",
  WwwNewsTextSection = "www_news_text_section",
  WwwNewsTextSectionWithInformation = "www_news_text_section_with_information",
  WwwNewsTextSectionWithQuote = "www_news_text_section_with_quote",
  WwwNewsVideoSection = "www_news_video_section",
}

export default ModelApiKeys;
